<template>
  <div :class="$style.switchLang">
    <button :class="[$style.btnLang, {[$style.btnActive]: isActive(localeType.RU)}]" @click="switchLang(localeType.RU)">
      {{ localeType.RU }}
    </button>
    <button :class="[$style.btnLang, {[$style.btnActive]: isActive(localeType.EN)}]" @click="switchLang(localeType.EN)">
      {{ localeType.EN }}
    </button>
  </div>
</template>

<script>
import { LOCALE_TYPE } from '@/api/i18n/const/localeType';

export default {
  computed: {
    localeType() {
      return LOCALE_TYPE;
    },
  },
  methods: {
    isActive(lang) {
      return this.$i18n.locale === lang;
    },
    switchLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('locale', lang);
      this.$router.go();
    },
  },
};
</script>

<style lang="scss" module>
  .switchLang {
    color: grey;
    gap: 10px;
    align-items: center;
  }

  .btnLang {
    cursor: pointer;
    padding: 0;
    border: none;
    font: inherit;
    color: grey;
    background-color: transparent;
    &:hover {
      opacity: 0.7;
      transition: opacity 200ms linear;
    }
  }

  .btnActive {
    border-bottom: 1px solid gray;
  }
</style>
